import { Box, Card, Typography } from "@mui/material";
import React from "react";
import { useDropzone } from "react-dropzone";

type DropzoneCardProps = {
  text: string;
  onDrop: (acceptedFiles: File[]) => void;
};

const DropzoneCard = ({ text, onDrop }: DropzoneCardProps) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <Card
      sx={{
        m: 1,
        p: 1,
        backgroundColor: "#ffffff",
        cursor: "pointer",
      }}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      <Box
        sx={{
          p: 3,
          border: "2px dashed",
          borderColor: isDragActive ? "#000000" : "transparent",
        }}
      >
        <Typography variant="h5">{text}</Typography>
        <Typography variant="caption">
          By uploading files to Trail Companion, you confirm that you have the
          necessary rights to use, share, and distribute this content. Trail
          Companion is not responsible for the legality of user-uploaded files.
        </Typography>
      </Box>
    </Card>
  );
};

export default DropzoneCard;
